import { render, staticRenderFns } from "./StudyDashboard.vue?vue&type=template&id=d0501c4e&scoped=true&"
import script from "./StudyDashboard.vue?vue&type=script&lang=js&"
export * from "./StudyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StudyDashboard.vue?vue&type=style&index=0&id=d0501c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0501c4e",
  null
  
)

export default component.exports